@if (updateAvailable$ | async; as update) {
  <aside
    class="app-update-banner"
    role="status"
    aria-live="polite"
    [attr.data-build-id]="update.buildId"
    data-testid="app-update-banner">
    <div class="app-update-banner-copy">
      <strong>{{ 'APP_UPDATE_TITLE' | translate }}</strong>
      <span>{{ 'APP_UPDATE_MESSAGE' | translate }}</span>
    </div>
    <div class="app-update-banner-actions">
      <button
        type="button"
        class="app-update-later"
        (click)="snooze()"
        [disabled]="reloading"
        data-testid="app-update-later">
        {{ 'APP_UPDATE_LATER' | translate }}
      </button>
      <button
        type="button"
        class="app-update-reload"
        (click)="reloadNow()"
        [disabled]="reloading"
        data-testid="app-update-reload">
        {{ 'APP_UPDATE_RELOAD' | translate }}
      </button>
    </div>
  </aside>
}
